import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserdataModel } from '../providers/userdata-model';

/* Games data are in the variable gamesData in this provider */

@Injectable()
export class GameModel {
    /* This contains a selection of games, not all. The games contained are
    - the ones not versus having the idChunkInBookInitial of idChunkInBookFinal equal to the currentChunk that is in the bookinfo for any books 
    (the ones needed to compile the arrays containing attempt made before to fill hangman letter already guessed and disable on keyboard letters yet tried)
    - the last game (to retrieve the last game id) */
    gamesData: any=[];

    /* This two objects maintain 'open' challenges NOT ALL the games pvp */
    gamesDataPVPAsync: any=[];
    gamesDataPVPSync: any=[];

    constructor(private storage: Storage, public userdataModel:UserdataModel){
        this.getGamesDataStored();
    }

    addWord(
        idBook:number,
        idGame: number,
        round:number,
        attempt:number,
        bookmarkLetter:number,
        time:number,
        tsInsert:number,
        word:string,
        wordToGuess: string,
        isCorrect:boolean,
        scoreEarned:number,
        attemptsWrong:number,
        timesWasPlayed:number){
        this.gamesData[this.getArrayPositionLastGame()].wordstyped.push({
            idBook: idBook,
            round: round,
            attempt: attempt,
            bookmarkLetter: bookmarkLetter,
            time: time,
            tsInsert: tsInsert,
            word: word,
            wordToGuess: wordToGuess,
            isCorrect: isCorrect,
            scoreEarned: scoreEarned,
            attemptsWrong: attemptsWrong,
            timesWasPlayed: timesWasPlayed
        });
        this.storeGamesData();
    }

    addGame(
        guidUser: string,
        idGame: number,
        idBook:number,
        currentDevice:any,
        numLetterGuessableSimul: number,
        numCharacterPriorOrPosterior: number,
        coefficentGoAheadOnCutBook: number,
        numLetterToConsiderInASingleGame: number,
        booksPlayable: string,
        booksPlayableInVersus: string,
        keyboards:string,
        tsBegingame:number,
        tsEndgame:number,
        gamemode: string,
        language:string,
        scoreInitial:number,
        scoreFinal:number,
        parVersion: number,
        bookmarkLetterInitial:number,
        bookmarkLetterFinal:number,
        idChunkInBookInitial:number,
        idChunkInBookFinal:number,
        levelInitial:number,
        levelFinal:number,
        fartherIndexDashReachedDuringGame:number,
        numCorrette: number,
        numSbagliate: number,
        priorOrPosteriorIndexes:string,
        giveup:boolean,
        win:boolean,
        isVersus: string,
        sent: string,
        accepted: string,
        declined: string,
        rewarded: string,
        guidUserVersus: string,
        idGameVersus: string,
        timeFinal:number,
        down_entropy:number,
        up_entropy:number,
        timesWasPlayed:number,
        wordstyped:any){
        this.gamesData.push({
            guidUser:guidUser,
            idGame:idGame,
            idBook: idBook,
            currentDevice: currentDevice,
            numLetterGuessableSimul: numLetterGuessableSimul,
            numCharacterPriorOrPosterior: numCharacterPriorOrPosterior,
            coefficentGoAheadOnCutBook: coefficentGoAheadOnCutBook,
            numLetterToConsiderInASingleGame: numLetterToConsiderInASingleGame,
            booksPlayable: booksPlayable,
            booksPlayableInVersus: booksPlayableInVersus,
            keyboards: keyboards,
            tsBegingame: tsBegingame,
            tsEndgame: tsEndgame,
            gamemode: gamemode,
            language: language,
            scoreInitial: scoreInitial,
            scoreFinal: scoreFinal,
            parVersion: parVersion,
            bookmarkLetterInitial:bookmarkLetterInitial,
            bookmarkLetterFinal:bookmarkLetterFinal,
            idChunkInBookInitial:idChunkInBookInitial,
            idChunkInBookFinal:idChunkInBookFinal,
            levelInitial: levelInitial,
            levelFinal: levelFinal,
            fartherIndexDashReachedDuringGame:fartherIndexDashReachedDuringGame,
            numCorrette:numCorrette,
            numSbagliate:numSbagliate,
            priorOrPosteriorIndexes:priorOrPosteriorIndexes,
            giveup:giveup,
            win:win,
            isVersus: isVersus,        
            sent: sent,
            accepted: accepted,
            declined: declined,
            rewarded: rewarded,
            guidUserVersus: guidUserVersus,
            idGameVersus: idGameVersus,
            timeFinal: timeFinal,
            down_entropy: down_entropy,
            up_entropy: up_entropy,
            timesWasPlayed: timesWasPlayed,
            wordstyped: wordstyped || []
        });

        this.storeGamesData();
    }

    getFirstWordtyped(){
        if (this.gamesData[this.getArrayPositionLastGame()].wordstyped.length==0) {
            return {};
        }else{
            return this.gamesData[this.getArrayPositionLastGame()].wordstyped[0];
        }
    }

    getLastWordtyped(){
        return this.gamesData[this.getArrayPositionLastGame()].wordstyped[this.gamesData[this.getArrayPositionLastGame()].wordstyped.length-1];
    }

    getNewGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.getIdLastGame()+1;
        }
        console.log("++++ New game id: "+idGame);
        return idGame;
    }

    getCurrentGameId(){
        var idGame;
        if(this.gamesData.length==0){ 
            idGame=0;
        }else{
            idGame=this.getIdLastGame();
        }
        return idGame;
    }

    /*removeItem(gameData){
        var i:number;
        for(i = 0; i < this.gameData.length; i++) {
            if(this.gameData[i] == item){
                this.gameData.splice(i, 1);
            }
        }
    }*/

    getNumGamesPlayed(){
        if (this.gamesData.length==0) {
            return 0;
        }else{
            // it should be + 1 for ids are zero based, but this way we don't count the current game
            return this.getIdLastGame();
        }
    }

    getIdLastGame(){
        return this.getLastGameData().idGame;
    }

    getArrayPositionLastGame(){
        return this.gamesData.length-1;
    }

    // This maintain funcionality if gameid are not sequential
    getArrayPositionGameWithId(idGame){
        for (let i = (this.gamesData.length-1); i >= 0; i--) {
            if (this.gamesData[i].idGame==idGame) {
                return i;
            }
        }
        return -1;
    }

    getRandomIntBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /* --------- GETTER/SETTER --------- */

    setWholeGamesData(gamesdata){
        this.gamesData=gamesdata;
        this.storeGamesData();
    }

    getWholeGamesData(){
        return this.gamesData;
    }

    setWholeGamesDataPVPAsync(gamesdataPVPAsync){
        this.gamesDataPVPAsync=gamesdataPVPAsync;
        this.storeGamesDataPVPAsync();
    }
    
    setWholeGamesDataPVPSync(gamesdataPVPSync){
        this.gamesDataPVPSync=gamesdataPVPSync;
        this.storeGamesDataPVPSync();
    }

    getWholeGamesDataPVPAsync(){
        return this.gamesDataPVPAsync;
    }
    getWholeGamesDataPVPSync(){
        return this.gamesDataPVPSync;
    }

    getGameSentDataPVPAsync(guidUser,idGame){
        return this.gamesDataPVPAsync.filter(obj=>obj.guidUser==guidUser && obj.idGame==idGame);
    }

    storeGamesData(){
        return new Promise((resolve) =>{
            this.storage.set('gamesData', JSON.stringify(this.gamesData)).then((val) => {
                resolve("storeGamesDataOk");
            })
        });
    }

    storeGamesDataPVPAsync(){
        return new Promise((resolve) =>{
            this.storage.set('gamesDataPVPAsync', JSON.stringify(this.gamesDataPVPAsync)).then((val) => {
                resolve("storeGamesDataOk");
            })
        });
    }
    storeGamesDataPVPSync(){
        return new Promise((resolve) =>{
            this.storage.set('gamesDataPVPSync', JSON.stringify(this.gamesDataPVPSync)).then((val) => {
                resolve("PVP storeGamesDataOk");
            })
        });
    }

    getGamesDataStored(){
        this.storage.get('gamesData').then((gamesData) => {
            if(gamesData){
                this.gamesData=JSON.parse(gamesData);
            }else{
                this.gamesData=[];
            }
        });
    }

    getGamesDataPVPAsyncStored(){
        this.storage.get('gamesDataPVPAsync').then((gamesDataPVPAsync) => {
            if(gamesDataPVPAsync){
                this.gamesDataPVPAsync=JSON.parse(gamesDataPVPAsync);
            }else{
                this.gamesDataPVPAsync=[];
            }
        });
    }

    clearGamesData(){
        return new Promise((resolve) =>{
            this.gamesData=[];
            this.gamesData.push({});
            this.storeGamesData().then((response)=>{
                resolve("storeGamesDataOk");
            });
        });
    }
    
    clearGamesDataPVPAsync(){
        return new Promise((resolve) =>{
            this.gamesDataPVPAsync=[];
            this.gamesDataPVPAsync.push({});
            this.storeGamesDataPVPAsync().then((response)=>{
                resolve("storeGamesDataPVPAsyncOk");
            });
        });
    }

    getLastGameData(){
        return this.gamesData[this.getArrayPositionLastGame()];
    }

    setTsEndgame(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].tsEndgame=value;
        this.storeGamesData();
    }

    getTsEndgame(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].tsEndgame;
    };

    setScoreFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].scoreFinal=value;
        this.storeGamesData();
    }

    getScoreFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].scoreFinal;
    };

    setPriorOrPosteriorIndexes(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].priorOrPosteriorIndexes=value;
        this.storeGamesData();
    }

    getPriorOrPosteriorIndexes(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].priorOrPosteriorIndexes;
    };

    setBookmarkLetterFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkLetterFinal=value;
        this.storeGamesData();
    }

    getBookmarkLetterFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].bookmarkLetterFinal;
    };

    setIdChunkInBookInitial(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookInitial=value;
        this.storeGamesData();
    }

    getIdChunkInBookInitial(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookInitial;
    };

    setIdChunkInBookFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookFinal=value;
        this.storeGamesData();
    }

    getIdChunkInBookFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].idChunkInBookFinal;
    };

    setLevelInitial(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].levelInitial=value;
        this.storeGamesData();
    }

    getLevelInitial(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].levelInitial;
    };

    setLevelFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].levelFinal=value;
        this.storeGamesData();
    }

    getLevelFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].levelFinal;
    };

    setFartherIndexDashReachedDuringGame(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].fartherIndexDashReachedDuringGame=value;
        this.storeGamesData();
    }

    getFartherIndexDashReachedDuringGame(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].fartherIndexDashReachedDuringGame;
    };

    setNumCorrette(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].numCorrette=value;
        this.storeGamesData();
    }

    getNumCorrette(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].numCorrette;
    };

    setNumSbagliate(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].numSbagliate=value;
        this.storeGamesData();
    }

    getNumSbagliate(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].numSbagliate;
    }

    setGiveUp(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].giveup=value;    
        this.storeGamesData();    
    }

    getGiveUp(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].giveup;
    };
    
    setWin(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].win=value;    
        this.storeGamesData();    
    }

    getWin(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].win;
    };

    setIsVersus(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].isVersus=value;    
        this.storeGamesData();    
    }

    getIsVersus(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].isVersus;
    };
    
    setTimeFinal(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].timeFinal=value;
        this.storeGamesData();
    }

    getTimeFinal(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].timeFinal;
    };

    setDownEntropy(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].down_entropy=value;
        this.storeGamesData();
    }

    getDownEntropy(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].down_entropy;
    };

    setUpEntropy(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].up_entropy=value;
        this.storeGamesData();
    }

    getUpEntropy(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].up_entropy;
    };

    setTimesWasPlayed(idGame,value){
        this.gamesData[this.getArrayPositionGameWithId(idGame)].timesWasPlayed=value;
        this.storeGamesData();
    }

    getTimesWasPlayed(idGame){
        return this.gamesData[this.getArrayPositionGameWithId(idGame)].timesWasPlayed;
    };

    /* --------- END --------- GETTER/SETTER --------- */
}



/*
OLD CODE

// Avoiding to choose chunk already played
    chooseRandomChunkForVersusPVPAsync(idBook){
        var chunkAlreadyPlayed=this.getChunkAlreadyPlayedInVersusGamemodeOfBook(idBook);
        var numchunktotalOfBook=this.userdataModel.getNumchunktotalOfBook(idBook);
        var randomChunk=this.getRandomIntBetween(0,numchunktotalOfBook-1);

        // If all chunks have been played, take also chunk already played (in order not chunk to finish)
        if (chunkAlreadyPlayed.length>=numchunktotalOfBook-5) {
            return randomChunk;
        }else{
            var i=0; // just to avoid infinite loop
            while(chunkAlreadyPlayed.indexOf(randomChunk) > -1 && i<40 ){
                i++;
                randomChunk=this.getRandomIntBetween(0,numchunktotalOfBook-1);
            }
            return randomChunk;
        }
    }
    
    getChunkAlreadyPlayedInVersusGamemodeOfBook(idBook){
        var filtered=this.gamesData.filter(obj=>obj.isVersus!=false && obj.idBook==idBook);
        var chunkAlreadyPlayed=[];
        for (let i = 0; i < filtered.length; i++) {
            chunkAlreadyPlayed.push(filtered[i].idChunkInBookInitial);
        }
        return chunkAlreadyPlayed;
    }

    getTimesGamePlayedPVPAsync(guidUser,idBook,idChunk){
        return this.gamesDataPVPAsync.filter(obj=>obj.guidUser==guidUser && obj.idBook==idBook && obj.idChunkInBookInitial==idChunk).length;
    }
    
    getTimesGamePlayedPVPSync(guidUser,idBook,idChunk){
        return this.gamesDataPVPSync.filter(obj=>obj.guidUser==guidUser && obj.idBook==idBook && obj.idChunkInBookInitial==idChunk).length;
    }
    
*/


// WEBPACK FOOTER //
// ./src/providers/game-model.ts